export default "__VITE_ASSET__2f66b15d__"